import { AbstractApiClient } from "../AbstractApiClient/AbstractApiClient";
import { fetchWebhookEvents } from "./fetchWebhookEvents/fetchWebhookEvents";

export class GarakClient extends AbstractApiClient {
  public readonly FetchWebhookEvents = fetchWebhookEvents(this.Instance);
}
